<template>
  <div id="addintegralGoods">
    <div class="rightHead">
      <div style="margin:0 0 0 30px;font-size:15px;padding-top:16px;color:#707070;" v-if="$route.meta.titleShow">{{$route.name}}</div>
    </div>
    <div class="invoicingHead" style="height: 40px">
      <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a @click="jumpTT('integralManage')" href="javascript:;">积分商品</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item v-if="$route.query.style == 'create'"
          >新增商品</el-breadcrumb-item
        >
        <el-breadcrumb-item v-if="$route.query.style == 'update'"
          >编辑商品</el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <div class="searchGroup">
      <el-form ref="ruleForm" :model="ruleForm" label-width="140px">
        <el-form-item label="商品名称：">
          <el-input
            v-model="ruleForm.goodsName"
            autofocus="true"
            style="width: 480px"
            maxlength="10"
            placeholder="输入商品名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品条形码：">
          <el-input
            v-model="ruleForm.goodsBarCode"
            style="width: 480px"
            placeholder="输入商品条形码"
            onchange = "this.value=this.value.replace(/[^\d]/g,'')"
          ></el-input>
        </el-form-item>
        <el-form-item label="兑换商品所需积分：">
          <el-input
            v-model="ruleForm.retailScore"
            style="width: 480px"
            placeholder="输入兑换商品所需积分"
          ></el-input>
        </el-form-item>
        <el-form-item label="主图">
          <el-upload
            action="http://192.168.1.33:8888/ImageServer/YmUpload_image"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :http-request="loadImg"
            :show-file-list = true
            :file-list="fileList"
            :class="{ hide: hideUpload }"
            :on-change="handleEditChange"
            :limit="1"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </el-form-item>
        <el-form-item label="图片附件">
          <el-upload
            action="http://192.168.1.33:8888/ImageServer/YmUpload_image"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove1"
            :http-request="loadImg1"
            :show-file-list = true
            :file-list="fileList1"
            :class="{ hide: hideUpload1 }"
            :on-change="handleEditChange1"
            :limit="6"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </el-form-item>
        <el-form-item label="选择分类：">
          <el-select
            v-model="ruleForm.officialGoodsCategoryId"
            placeholder="请选择"
          >
            <el-option
              v-for="item in goodsCategoryList"
              :key="item.officialGoodsCategoryId"
              :label="item.categoryName"
              :value="item.officialGoodsCategoryId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择单位：">
          <!-- <el-select v-model="ruleForm.goodsUnitId" placeholder="商品单位">
            <el-option
              v-for="item in unitsList"
              :key="item.goodsUnitId"
              :label="item.goodsUnit"
              :value="item.goodsUnitId"
            ></el-option>
          </el-select> -->
          <el-input
            v-model="ruleForm.goodsUnitId"
            style="width: 480px"
            placeholder="输入单位"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品库存">
          <template>
            <el-radio-group v-model="ruleForm.isInfiniteStock">
              <el-radio :label="1">无限库存</el-radio>
              <el-radio :label="0">有限库存</el-radio>
            </el-radio-group>
          </template>
          <el-input v-show="ruleForm.isInfiniteStock == 0" style="width: 200px;padding-left:10px;" v-model="ruleForm.totalStockCount" placeholder="输入库存数量"></el-input>
        </el-form-item>
        <el-form-item label="商品描述：">
          <el-input
            v-model="ruleForm.goodsDescription"
            style="width: 480px"
            placeholder="输入商品描述"
            type="textarea"
          ></el-input>
        </el-form-item>
        <el-form-item label="填写备注：">
          <el-input
            placeholder="输入备注信息"
            type="textarea"
            style="width: 480px"
            v-model="ruleForm.goodsRemark"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveForm">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { uploadImg, getOfficialGoodsCategoryList, goodsUnitList, modifyOrSaveOfficialGoods, getSingleOfficialGoods } from "../api";
export default {
  data() {
    return {
      ruleForm: {
        goodsName: "",
        goodsImage: "",
        goodsImages: "",
        goodsDescription: "",
        goodsUnitId: "",
        retailScore: "",
        goodsRemark: "",
        isInfiniteStock: false,
        totalStockCount: "",
        officialGoodsCategoryId: "",
        goodsBarCode: "",
        isInfiniteStock: 1,
        totalStockCount: ""
      },
      goodsImage1: [],
      goodsImage2: [],
      dialogImageUrl: "",
      unitsList: [],
      goodsCategoryList: [],
      dialogVisible: false,
      hideUpload: false,
      hideUpload1: false,
      fileList: [],
      fileList1: [],
      bool: false
    };
  },
  name: "addintegralGoods",
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    this.userList = userList;
    this.getOfficialGoodsCategoryList()
    if (this.$route.query.style == 'update') {
      this.getSingleOfficialGoods()
      this.hideUpload = this.fileList.length >= 0;
      this.hideUpload1 = this.fileList1.length >= 6;
    }
  },
  methods: {
    //跳转
    jumpTT(adress, message) {
      this.$router.push({ path: adress, query: { docId: message } });
    },
    handleEditChange(file, fileList) {
      this.hideUpload = fileList.length >= 1;
    },
    handleEditChange1(file, fileList) {
      this.hideUpload1 = fileList.length >= 6;
    },
    handleRemove1(file, fileList) {
      console.log(file, fileList)
      this.goodsImage1.push(file.url)
      fileList.forEach(item => {
        this.goodsImage2.unshift(item.url)
      })
      this.hideUpload1 = fileList.length >= 6;
    },
    // 移除
    handleRemove(file, fileList) {
      this.hideUpload = fileList.length >= 1;
    },
    // 放大
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    loadImg(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      console.log(imgUploadForm, "imgUploadForm");
      uploadImg(imgUploadForm)
        .then((res) => {
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.ruleForm.goodsImage = res.data.data.url
            this.dialogImageUrl = res.data.data.url;
          } else if (res.data.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((res) => {});
    },
    loadImg1(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      console.log(imgUploadForm, "imgUploadForm");
      uploadImg(imgUploadForm)
        .then((res) => {
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.ruleForm.goodsImages += ',' + res.data.data.url + ',';
            this.ruleForm.goodsImages = this.ruleForm.goodsImages.substring(0, this.ruleForm.goodsImages.lastIndexOf(','));
            if (this.ruleForm.goodsImages.substr(0,1)==',')  this.ruleForm.goodsImages=this.ruleForm.goodsImages.substr(1);
            this.dialogImageUrl = res.data.data.url;
          } else if (res.data.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((res) => {});
    },
    saveForm() {
      console.log(this.ruleForm, 1111)
      console.log(this.goodsImage1, "被删掉的图片地址")
      console.log(this.goodsImage2, "剩下新的图片地址")
      var goodImgList = []
      goodImgList = this.ruleForm.goodsImages.split(',')
      this.goodsImage1.forEach(item1 => {
        var res = goodImgList.filter(item => {
          return item1 !== item && item
        })
        console.log(res, "新的附件图")
        this.ruleForm.goodsImages = ""
        res.forEach(element => {
          this.ruleForm.goodsImages += ',' + element + ',';
          this.ruleForm.goodsImages = this.ruleForm.goodsImages.substring(0, this.ruleForm.goodsImages.lastIndexOf(','));
        })
        if (this.ruleForm.goodsImages.substr(0,1)==',')  this.ruleForm.goodsImages=this.ruleForm.goodsImages.substr(1);
      })
      modifyOrSaveOfficialGoods({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        officialGoodsId: this.$route.query.style == 'update' ? this.$route.query.goodsId : null,
        officialGoodsCategoryId: this.ruleForm.officialGoodsCategoryId,
        goodsBarCode: this.ruleForm.goodsBarCode,
        goodsName: this.ruleForm.goodsName,
        goodsImages: this.ruleForm.goodsImages,
        goodsImage: this.ruleForm.goodsImage,
        goodsDescription: this.ruleForm.goodsDescription,
        unit: this.ruleForm.goodsUnitId,
        retailScore: this.ruleForm.retailScore,
        goodsRemark: this.ruleForm.goodsRemark,
        isInfiniteStock: this.ruleForm.isInfiniteStock,
        totalStockCount: this.ruleForm.totalStockCount
      })
      .then(res => {
        if (res.code == 1) {
          this.$message.success(res.msg)
          this.$router.push('/integralManage')
          this.ruleForm = {}
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    // 获取商品分类列表
    getOfficialGoodsCategoryList() {
      getOfficialGoodsCategoryList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        pageNo: 1,
        row: 999
      })
      .then(res => {
        // this.getGoodsUnitList()
        if (res.code == 1) {
          this.goodsCategoryList = res.data
          this.ruleForm.officialGoodsCategoryId =  this.goodsCategoryList[0].officialGoodsCategoryId
        } else if (res.code == -1) {
          this.goodsCategoryList = []
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取单位列表
    // getGoodsUnitList() {
    //   goodsUnitList({
    //     sessionId: this.userList.sessionId,
    //     userId: this.userList.id,
    //     pageNo: 1,
    //     row: 999
    //   })
    //   .then(res => {
    //     if (res.code == 1) {
    //       this.unitsList = res.data
    //       this.ruleForm.goodsUnitId =  this.unitsList[0].goodsUnitId
    //     } else if (res.code == -1) {
    //       this.unitsList = []
    //     } else if (res.code == 2) {
    //       this.$message.error(res.msg);
    //       this.$router.push("/");
    //     } else {
    //       this.$message.error(res.msg);
    //     }
    //   });
    // },
    // 商品详情
    getSingleOfficialGoods() {
      getSingleOfficialGoods({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        officialGoodsId: this.$route.query.goodsId
      })
      .then(res => {
        if (res.code == 1) {
          this.ruleForm = res.data
          console.log(this.ruleForm)
          if(res.data.goodsImage) {
            var imgList = res.data.goodsImage.split(',')
            imgList.forEach(item => {
              if (item) {
                this.fileList.unshift({name: "", url: item})
              }
            })
          }
          if (res.data.goodsImages) {
            var imgList1 = res.data.goodsImages.split(',')
            imgList1.forEach(item => {
              if (item) {
                this.fileList1.unshift({name: "", url: item})
              }
            })
          }
        } else if (res.code == -1) {
          this.ruleForm = {}
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
#addintegralGoods {
  width: calc(100vw - 217px);
  height: calc(100vh);
  margin-left: 200px;
  min-width: 1340px;
  .searchGroup {
    width: 100%;
    padding-top: 120px;
    padding-left: 20px;
    box-sizing: border-box;
  }
}
::v-deep .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}
::v-deep .el-icon-delete {
  display: block;
}
</style>
<style>
.hide .el-upload--picture-card {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/page/addintegralGoods.vue